import { Observable } from 'rxjs'
import { MbResourcesEntries } from '../../../models'

export abstract class MbProductTabResourcesAdapter {

  abstract load(productCode: string, maxCount?: number): Observable<MbResourcesEntries>
}
